export const STAGE: string = process.env.REACT_APP_STAGE || "beta";

export const API_DOMAIN: string =
  STAGE === "development"
    ? "localhost:3000"
    : STAGE === "alpha"
    ? "alpha.dockethealth.com"
    : STAGE === "beta"
    ? "beta.dockethealth.com"
    : STAGE === "prod"
    ? "dockethealth.com"
    : "";

export const LEGACY_API_DOMAIN: string =
  STAGE === "development"
    ? "localhost:3000"
    : STAGE === "alpha"
    ? "alpha.docket.care"
    : STAGE === "beta"
    ? "beta.docket.care"
    : STAGE === "prod"
    ? "docket.care"
    : "";

export const PROTOCOL: string = STAGE === "development" ? "http" : "https";

// Parse the URL and extract the subdomain
export const SUBDOMAIN = window.location.href.split(".")[0].split("://")[1];

// Supported languages
export const SUPPORTED_LANGUAGES = ["en", "en-US", "es", "hi", "uk"];

export const USE_WHITELABEL_BRANDING = STAGE === "prod" ? false : true;

// No development mode for apple sign in
export const REDIRECT_URI: string =
  STAGE !== "development"
    ? `https://${SUBDOMAIN}.${SUBDOMAIN === "app" ? "" : "app."}${API_DOMAIN}`
    : "http://localhost:3000"; // The library barfs if there's no string

// These should be all of the valid service worker message types
export enum SWMessageTypes {
  Login = "Login",
}

// Number of minutes before logout
export const IDLE_TIMEOUT: number = 5;

export const STAY_LOGGED_IN_PW = "D0ck3t*nTheW3B@@!!";

export function enumKeys<O extends object, K extends keyof O = keyof O>(obj: O): K[] {
  return Object.keys(obj).filter((k) => Number.isNaN(+k)) as K[];
}

export {};
